export const invertedMessages = {
  'Search applied': 'CERTS_EXPORT_SEARCH_APPLIED',
  'All Items': 'CERTS_EXPORT_WHAT_TO_EXPORT_ALL_ITEMS',
  'Only Filtered Results': 'CERTS_EXPORT_WHAT_TO_EXPORT_ONLY_FILTERED_RESULTS',
};
